import React from "react";
import { Logo } from "./Logo";
import { footerColumns } from "../../data/home";
export function Footer() {
  return <footer className="px-3 pb-3 md:px-5 md:pb-5" data-id="element-84" data-mp="3htas28jpijbc">
      <div className="mx-auto max-w-[1400px] rounded-[32px] bg-night px-5 pb-10 pt-16 md:rounded-[44px] md:px-12 md:pt-20" data-id="element-85" data-mp="32xd1r6wgs971">
        <div className="mx-auto max-w-7xl" data-id="element-86" data-mp="37vwkkyfrh4v6">
          <div className="grid gap-12 lg:grid-cols-12" data-id="element-87" data-mp="37ula6frt8yv3">
            <div className="lg:col-span-5" data-id="element-88" data-mp="2u4rilpox80ho">
              <Logo inverted data-id="element-89" data-mp="2u3q4fcclyxvq" />
              <p className="mt-5 max-w-sm text-[15px] leading-relaxed text-canvas/60" data-id="element-90" data-mp="2yvhor55687df">
                Conseil en investissement financier et courtage en assurance pour les
                particuliers et dirigeants.
              </p>
              <div className="mt-6 space-y-1 text-[15px] text-canvas" data-id="element-91" data-mp="2p6zruz00ikf2">
                <a href="tel:0130359188" className="block hover:underline" data-id="element-92" data-mp="2b5ncopsoemu8">
                  01 30 35 91 88
                </a>
                <a href="mailto:contact@lenouveauplacement.com" className="block hover:underline" data-id="element-93" data-mp="2f6h0lj64c1n4">
                  contact@lenouveauplacement.com
                </a>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-7" data-id="element-94" data-mp="3pr5krbba1zaq">
              {footerColumns.map(col => <div key={col.title} data-id="element-95" data-mp="8hqy21iukevv">
                  <h3 className="text-[15px] font-semibold text-canvas" data-id="element-96" data-mp="3k7d6irn93uy">{col.title}</h3>
                  <ul className="mt-4 space-y-3" data-id="element-97" data-mp="3c0ai4grdgefl">
                    {col.links.map(l => <li key={l} data-id="element-98" data-mp="371pgqe0dvopk">
                        <a href="#" className="text-[15px] text-canvas/60 transition-colors duration-150 hover:text-canvas" data-id="element-99" data-mp="372s7mlxphr5h">
                          {l}
                        </a>
                      </li>)}
                  </ul>
                </div>)}
            </div>
          </div>

          <div className="mt-16 border-t border-night-line pt-8" data-id="element-100" data-mp="2oa6focpx6kq6">
            <p className="text-xs leading-relaxed text-canvas/40" data-id="element-101" data-mp="3dzda5ps737qy">
              Le Nouveau Placement, SAS au capital de 100 000 €, R.C.S de Pontoise, SIREN
              N°795233675, société agréée Conseiller en Investissement Financier et Courtier en
              assurance, adhérente à l’ANACOFI-CIF, association professionnelle agréée par
              l’Autorité des Marchés Financiers (AMF), sous le numéro E008637, et enregistrée à
              l’ORIAS sous le numéro 13009531. Soumis au contrôle de l’ACPR, 61 rue Taitbout
              75436 Paris Cedex 09. Assurance et Garantie Financière RCP souscrite auprès de
              MMA-Covéa Risks — Police N° 229196.
            </p>
            <div className="mt-6 flex flex-col gap-3 text-xs text-canvas/50 sm:flex-row sm:justify-between" data-id="element-102" data-mp="38zquzast3hfi">
              <p data-id="element-103" data-mp="jb8130x63wkj">© 2026 Le Nouveau Placement</p>
              <div className="flex gap-6" data-id="element-104" data-mp="jaghypkrbrb5">
                <a href="#" className="hover:text-canvas" data-id="element-105" data-mp="o9jchg342f4v">Mentions légales</a>
                <a href="#" className="hover:text-canvas" data-id="element-106" data-mp="obmc8ru2fmms">Confidentialité</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}